<template>
  <div>
    <simple-wizard ref="wizard" class="wizard" prevButtonText="zurück" :nextButtonText="nextButtonText" :finishButtonText="finishButtonText"  @tab-change="onTabChanged">
      <template slot="header">
        <template v-if="!hasJoined">
          <h2  class="title">Jetzt mitmachen!</h2>
        </template>
        <template v-else>
          <h2 class="title">Hol dir zusätzliche Goodies</h2>
          <span>oder kauf weitere Tickets und lade deine Freunde ein, auch an der Challenge teilzunehmen.</span>
        </template>
      </template>

      <wizard-tab ref="codeTab" :before-change="validateCode" :tab-hidden="!tabsVisible.codeTab">
        <template slot="label">
          <md-icon>code</md-icon>
        </template>
        <span class="md-display-1">Challenge-Anmeldung</span>
        <cart-code-input
          v-if="isLoggedIn"
          ref="codeInput"
          :challengeId="challenge._id"
          :initialCode="initialCode"
          @code-info-updated="onCodeInfoUpdated($event)"
        />
        <div v-if="!isLoggedIn" style="margin-top: 30px">
          <div>
            <md-button
              class="md-round md-primary md-sm"
              @click="skipJoin()"
            >
              Kaufen
            </md-button>
            Jetzt die Tickets kaufen und später die Anmeldung durchführen oder einfach einem Freund schenken.
          </div>
          <div>
            <md-button
              class="md-round md-warning md-sm"
              @click="redirect('/Login')"
            >
              Anmelden
            </md-button>
            Bitte log dich vorher ein, damit du dich zu der Challenge anmelden kannst.
          </div>
          <div>
            <md-button
              class="md-round md-info md-sm"
              @click="redirect('/Register')"
            >
              Registriere dich jetzt
            </md-button>
            Falls du noch keinen Benutzer hast, bitte registriere dich.
          </div>
        </div>
      </wizard-tab>

      <wizard-tab ref="cartItemsTab" :before-change="validateCart" :tab-hidden="!tabsVisible.cartItemsTab">
        <template slot="label">
          <md-icon>add_shopping_cart</md-icon>
        </template>

        <div v-if="!availableMerchandise.length">
          <span class="md-display-1">Leider sind zurzeit keine Produkte mehr verfügbar.</span>
        </div>

        <template v-else>
          <span class="md-display-1">Produkte wählen</span>
          <cart-item-selection
            v-if="showItemSelector"
            @add-cart-item="addMerchandise($event)"
            :availableMerchandise="availableMerchandise"
            :currency="challenge.currency"
            :donationForm="challenge.hasSingleItemDonationOptions ? challenge.donationForm : undefined"
          />

          <hr v-if="cartItems.length"/>

          <fade-transition>
            <cart-summary
              v-if="cartItems.length"
              :cartItems="cartItems"
              :currency="challenge.currency"
              :priceInfo="priceInfo"
              :donationForm="donationFormFields"
              @delete="removeItem($event)"
            />
          </fade-transition>

          <fade-transition>
            <cart-voucher-input
              :currency="challenge.currency"
              :voucherInfo="priceInfo && priceInfo.voucherInfo"
              :joinCodeInfo="joinCodeInfo"
              @buttonClick="cartVoucherButtonClick($event)"
              v-model="voucherCode"/>
          </fade-transition>

          <fade-transition>
            <div v-if="priceInfoError" class="text-danger" style="text-align: center; margin-top:18px; cursor: pointer" @click="updatePriceInfo">
              Beim Aktualisieren des Warenkorbs ist leider ein Fehler aufgetreten. Klicke hier, um es erneut zu versuchen.
            </div>
          </fade-transition>

          <fade-transition>
            <div v-if="additionalTicketsInfo" class="md-subheading" :class="{ 'text-danger': canJoin && !doJoinWithTicket }" style="text-align: center; margin-top:18px;font-size: 20px;">
              {{additionalTicketsInfo}}
            </div>
          </fade-transition>
        </template>
      </wizard-tab>

      <wizard-tab ref="joinTab" :before-change="validateJoinForm" v-if="canJoin" :tab-hidden="!tabsVisible.joinTab">
        <template slot="label">
          <md-icon>assignment_ind</md-icon>
        </template>

        <cart-join-form
          v-if="joinOnlyWithJoinCode || doJoinWithTicket"
          ref="joinForm"
          :joinFormFields="joinFormFields"
          :joinCodeField="challenge.joinCodeField"
          :joinCode="joinCode"
          :donationFormFields="donationFormFields"
          :additionalFormFields="additionalFormFields"
        />

        <h3 v-else-if="canJoin">{{additionalTicketsInfo}}</h3>

      </wizard-tab>

      <wizard-tab ref="shippingTab" :before-change="validateShipping" :tab-hidden="!tabsVisible.shippingTab">
        <template slot="label">
          <md-icon>local_shipping</md-icon>
        </template>
        <div>
          <cart-shipping-form
            ref="shippingTabComponent"
            :hasShipping="hasShipping"
            :shippingForm="challenge.shippingInvoiceForm"
            :invoiceForm="challenge.shippingInvoiceForm"
            :countryField="challenge.shippingFormCountryField"
            @country-selected="selectedShippingCountry = $event"
          />
        </div>
      </wizard-tab>

      <wizard-tab ref="paymentTab" :tab-hidden="!tabsVisible.paymentTab" :before-change="doPayment">
        <template slot="label">
          <md-icon>payment</md-icon>
        </template>

        <span class="md-display-1">Bestellübersicht:</span>
        <cart-summary
          ref="summaryTabComponent"
          style="max-width: 600px; margin: 0 auto;"
          :readOnly="true"
          :cartItems="cartItems"
          :currency="challenge.currency"
          :priceInfo="priceInfo"
          :donationForm="donationFormFields"
          >
          <template v-slot:donationForm>
            <cart-donation-input
              ref="additionalDonationInput"
              style="max-width: 600px; margin: 0 auto;"
              v-if="challenge.hasAdditionalDonationField"
              :donationForm="challenge.hasAdditionalDonationOptions ? donationFormFields : undefined"
              @input="enteredAdditionalDonation = $event"
            />
          </template>
        </cart-summary>


        <dynamic-form
          ref="generalDonationOptions"
          v-if="challenge.hasGeneralDonationOptions && priceInfo.donationAmount > 0"
          :formFields="donationFormFields"
          style="max-width: 600px; margin: 0 auto;"
          :hideSubmit="true"
        />

        <dynamic-form
          ref="finalCheckoutOptions"
          v-if="challenge.finalCheckoutForm && challenge.finalCheckoutForm.length"
          :formFields="challenge.finalCheckoutForm"
          style="max-width: 600px; margin: 0 auto;"
          :hideSubmit="true"
        />

        <template v-if="priceInfo.payableAmount > 0">
          <span class="md-display-1">Zahlungspflichtig bestellen mit:</span>
          <cart-payment-options
            :disabled="startingPayment"
            :availableOptions="challenge.paymentMethods"
            v-model="paymentMethod"
          />
        </template>
      </wizard-tab>
    </simple-wizard>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { SimpleWizard, WizardTab } from "@/components";
import DynamicForm from '@/components/DynamicForm/DynamicForm';
import CartItemSelection from './CartItemSelection';
import CartSummary from './CartSummary';
import CartJoinForm from './CartJoinForm';
import CartShippingForm from './CartShippingForm';
import CartPaymentOptions from './CartPaymentOptions';
import CartVoucherInput from './CartVoucherInput';
import CartDonationInput from './CartDonationInput';
import CartCodeInput from './CartCodeInput.vue';
import { v4 as uuidv4 } from 'uuid';

export default {
  props: ['hasJoined', 'challenge', 'initialCode', 'initialVoucherCode'],
  components: {
    SimpleWizard,
    WizardTab,
    DynamicForm,
    CartItemSelection,
    CartSummary,
    CartJoinForm,
    CartShippingForm,
    CartPaymentOptions,
    CartVoucherInput,
    CartDonationInput,
    CartCodeInput,
  },
  data() {
    return {
      showItemSelector: false, // show only when tab comes into view so the height gets properly set
      paymentMethod: undefined,
      cartItems: [],
      selectedShippingCountry: undefined,
      enteredAdditionalDonation: undefined,
      codeInfo: undefined,
      voucherCode: undefined,
      priceInfo: {},
      priceInfoError: false,
      voucherItemAutoLoaded: false,
      startingPayment: false,
      joinFormFields: this.challenge && this.challenge.joinForm && this.challenge.joinForm.fields,
      donationFormFields: this.challenge && this.challenge.donationForm,
      joinCode: undefined,
      additionalFormFields: [],
      joinCodeInfo: undefined,
      tempCodeInfo: undefined,
      initialCodeResolved: false
    };
  },
  computed: {
    ...mapState({
      userId: state => state.user && state.user._id
    }),
    isLoggedIn() {
      return !!this.userId;
    },
    canJoin() {
      return !this.hasJoined && this.isLoggedIn;
    },
    doJoinWithTicket() {
      return this.canJoin && this.totalTickets > 0;
    },
    availableMerchandise() {
      const now = new Date();
      return this.challenge.merchandise.filter(i => {
        return (!i.activeUntil || now.getTime() <= new Date(i.activeUntil).getTime()) &&
               (!i.activeFrom || now.getTime() >= new Date(i.activeFrom).getTime())
      });
    },
    totalTickets() {
      return (this.priceInfo && this.priceInfo.totalTickets) || 0;
    },
    additionalTicketsInfo() {
      if (this.canJoin && !this.doJoinWithTicket) {
        return 'Wähle bitte ein Produkt aus, das ein Ticket enthält, wenn du dich zur Challenge anmelden willst.';
      }
      const friendsTickets = this.totalTickets - (this.doJoinWithTicket ? 1 : 0);

      if (!friendsTickets) {
        return '';
      }
      const zusaetzlich_zu_deiner_eigenen_Anmeldung = this.doJoinWithTicket ? 'zusätzlich zu deiner eigenen Anmeldung' : '';
      if (friendsTickets === 1) {
        return `In deiner Bestellung ist eine Anmeldemöglichkeit ${zusaetzlich_zu_deiner_eigenen_Anmeldung} enthalten. Du erhältst hierfür einen Anmelde-Code per E-Mail zugesandt, den du an einen Freund weitergeben kannst.`;
      }
      return `In deiner Bestellung sind ${friendsTickets} Anmeldemöglichkeiten ${zusaetzlich_zu_deiner_eigenen_Anmeldung} enthalten. Du erhältst hierfür Anmelde-Codes per E-Mail zugesandt, die du an deine Freunde weitergeben kannst.`;
    },
    hasShipping() {
      return !!(this.priceInfo && this.priceInfo.hasShipping);
    },
    joinOnlyWithJoinCode() {
      return this.codeInfo && this.codeInfo.type === 'joinCode';
    },
    tabsVisible() {
      // cart only: when user has already joined
      if (this.hasJoined || this.initialVoucherCode) {
        return {
          codeTab: false,
          cartItemsTab: true,
          shippingTab: true,
          joinTab: true,
          paymentTab: true
        };
      }
      // enter code and then join form only: when user is has not yet joined and user has entered a join code in previous tab
      if (!this.isTabActive(this.$refs.codeTab) && this.joinOnlyWithJoinCode) {
        return {
          codeTab: true,
          cartItemsTab: false,
          shippingTab: false,
          joinTab: true,
          paymentTab: false
        };
      }
      // normal with enter code, cart, shipping, join form: when user has not yet joined and has yet to enter a code or has entered a voucher code or no code
      return {
        codeTab: true,
        cartItemsTab: true,
        shippingTab: true,
        joinTab: true,
        paymentTab: true
      };
    },
    nextButtonText() {
      return this.joinOnlyWithJoinCode ? 'zur Anmeldung' : 'weiter'
    },
    finishButtonText() {
      return this.joinOnlyWithJoinCode ? 'anmelden' : 'Bestellung aufgeben'
    }
  },
  watch: {
    cartItems: {
      deep: true,
      handler: 'updatePriceInfo'
    },
    selectedShippingCountry: 'updatePriceInfo',
    enteredAdditionalDonation: 'updatePriceInfo',
    voucherCode: 'updateVoucherCode',
    // voucherCode: 'updatePriceInfo',
  },
  mounted() {
    if(this.initialVoucherCode!==undefined) this.voucherCode = this.initialVoucherCode;
    this.showItemSelector = this.isTabActive(this.$refs.cartItemsTab)
  },
  methods: {
    isTabActive(tab) {
      return !!(this.$refs.wizard && this.$refs.wizard.visibleTabs[this.$refs.wizard.activeTabIndex] === tab);
    },
    onTabChanged(oldTab, newTab) {
      this.showItemSelector = this.isTabActive(this.$refs.cartItemsTab);
      this.resetWizardTabsCheckedState(this.$refs.wizard.activeTabIndex + 1);
    },
    onCodeInfoUpdated(codeInfo = {}) {
      if (codeInfo.pageInfo) {
        this.$root.$emit('codeInfoUpdated', codeInfo.pageInfo)
        this.$emit('codeInfoUpdated', codeInfo.pageInfo)
      }
      this.codeInfo = codeInfo;
      this.additionalFormFields = codeInfo.joinForm && codeInfo.joinForm.additionalFields;
      this.voucherCode = codeInfo.type == 'voucherCode' ? codeInfo.code : undefined;
      this.joinCode = codeInfo.type == 'joinCode' ? codeInfo.code : undefined;

      const challengeJoinFormFields = (this.challenge && this.challenge.joinForm && this.challenge.joinForm.fields) || [];
      const overrideFields = (codeInfo.joinForm && codeInfo.joinForm.fields) || [];

      this.joinFormFields = challengeJoinFormFields.map(formField =>  {
        const overrideField = overrideFields.find(f => f.name && formField.name === f.name);
        return overrideField ? { ...formField, ...overrideField } : formField;
      });

      const challengeDonationFields = (this.challenge && this.challenge.donationForm) || [];
      const overrideDonationFields = (codeInfo.donationForm && codeInfo.donationForm.fields) || [];

      this.donationFormFields = challengeDonationFields.map(field =>  {
        const overrideField = overrideDonationFields.find(f => f.name && field.name === f.name);
        return overrideField ? { ...field, ...overrideField } : field;
      });

      // if code is provided via initalCode, i.e. via url get param, then automatically skip to next tab after code has been verified
      if (!this.initialCodeResolved && this.initialCode && this.initialCode.toUpperCase() === codeInfo.code.toUpperCase()) {
        this.initialCodeResolved = true;
        this.$refs.wizard.nextTab();
      }
    },
    updateVoucherCode(codeInputValue) {
      this.$store.dispatch("queryAPI", {
        url: `/rest/challenge/checkCode/${this.challenge._id}/${codeInputValue}`
      })
          .then(codeInfo => {
            this.tempCodeInfo = codeInfo;
            if (codeInfo.type == 'joinCode') {
            // TODO: refactor all this duplicated code
              this.joinCodeInfo = this.isLoggedIn ? { authorized: true } : { unauthorized: true };
              this.joinCode = codeInfo.code;

              this.additionalFormFields = codeInfo.joinForm && codeInfo.joinForm.additionalFields;
              const challengeJoinFormFields = (this.challenge && this.challenge.joinForm && this.challenge.joinForm.fields) || [];
              const overrideFields = (codeInfo.joinForm && codeInfo.joinForm.fields) || [];

              this.joinFormFields = challengeJoinFormFields.map(formField =>  {
                const overrideField = overrideFields.find(f => f.name && formField.name === f.name);
                return overrideField ? { ...formField, ...overrideField } : formField;
              });

              const challengeDonationFields = (this.challenge && this.challenge.donationForm) || [];
              const overrideDonationFields = (codeInfo.donationForm && codeInfo.donationForm.fields) || [];

              this.donationFormFields = challengeDonationFields.map(field =>  {
                const overrideField = overrideDonationFields.find(f => f.name && field.name === f.name);
                return overrideField ? { ...field, ...overrideField } : field;
              });
            } else if (codeInfo.type == 'voucherCode') {
              this.updatePriceInfo();

              this.additionalFormFields = codeInfo.joinForm && codeInfo.joinForm.additionalFields;
              const challengeJoinFormFields = (this.challenge && this.challenge.joinForm && this.challenge.joinForm.fields) || [];
              const overrideFields = (codeInfo.joinForm && codeInfo.joinForm.fields) || [];

              this.joinFormFields = challengeJoinFormFields.map(formField =>  {
                const overrideField = overrideFields.find(f => f.name && formField.name === f.name);
                return overrideField ? { ...formField, ...overrideField } : formField;
              });

              const challengeDonationFields = (this.challenge && this.challenge.donationForm) || [];
              const overrideDonationFields = (codeInfo.donationForm && codeInfo.donationForm.fields) || [];

              this.donationFormFields = challengeDonationFields.map(field =>  {
                const overrideField = overrideDonationFields.find(f => f.name && field.name === f.name);
                return overrideField ? { ...field, ...overrideField } : field;
              });
            }
          })
          .catch(err => {
            this.joinCodeInfo = undefined;
            this.codeError = true;
          })
    },
    cartVoucherButtonClick(buttonType) {
      if (buttonType == 'yes') {
        if (this.tempCodeInfo.pageInfo) {
          this.$emit('codeInfoUpdated', this.tempCodeInfo.pageInfo)
        }
        this.codeInfo = this.tempCodeInfo;
      } else if (buttonType == 'no') {
        this.joinCodeInfo = undefined;
        this.voucherCode = undefined;
      }
    },
    updatePriceInfo() {
      this.priceInfoError = false;
      this.$api.calculatePrices({
        challengeId: this.challenge._id,
        cartItems: this.cartItems,
        shippingCountry: this.selectedShippingCountry,
        voucherCode: this.voucherCode,
        additionalDonation: this.enteredAdditionalDonation
      }).then(priceInfo => {
        this.priceInfo = priceInfo;
        if (this.voucherItemAutoLoaded !== this.voucherCode &&
            priceInfo &&
            priceInfo.voucherInfo &&
            priceInfo.voucherInfo.applicableMerchandise) {
            this.voucherItemAutoLoaded = this.voucherCode;
            for (const item of priceInfo.voucherInfo.applicableMerchandise) {
              if ((!item.options || !item.options.length) &&
                  (!this.challenge.hasSingleItemDonationOptions || !item.donationAmount || !item.donationForm || !item.donationForm.length)) {
                if (!this.cartItems.find(c => c.merchandise._id === item._id)) {
                  // TODO not removeable if it's a -100% voucher
                  this.addMerchandise({ merchandise: item });
                }
              }
            }
          }
      }).catch(e => {
        console.error(e);
        this.priceInfo = {};
        this.priceInfoError = true;
      });
    },
    resetWizardTabsCheckedState(index) {
      const tabs = this.$refs.wizard.tabs;
      for (let i = index; i < tabs.length; i++) {
        tabs[i].checked = false;
      }
    },
    addMerchandise(item) {
      this.cartItems.push({
        key: uuidv4(),
        ...item,
      });
    },
    removeItem(item) {
      this.cartItems = this.cartItems.filter(i => i !== item);
    },
    validateCode() {
      if (this.userId==null) return true;
      return this.$refs.codeInput.validate();
    },
    validateCart() {
      if (!this.priceInfo || this.priceInfoError) {
        return false;
      }
      if (!this.cartItems.length) {
        this.$notify({
          timeout: 5000,
          message: "Wähle mindestens ein Produkt aus.",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "warning"
        });
        return false;
      }
      return true;
    },
   async validateJoinForm() {
    //!this.doJoinWithTicket was removed because it was causing the join form to be valid event when it wasn't
    //this was happening when the user enters a join code in the first tab
      const isValid = !this.$refs.joinForm || await this.$refs.joinForm.validate();
      if (isValid && this.joinCode) {
        this.$emit('submit-join-form', this.$refs.joinForm.getFormData())
        return isValid;
      }
      return isValid;
    },
    skipJoin() {
      this.doJoin = false;
      this.$nextTick(() => {
        this.$refs.wizard.nextTab();
      });
    },
    validateShipping() {
      return this.$refs.shippingTabComponent.validate();
    },
    async validateCheckout() {
      if (!this.priceInfo || this.priceInfoError) {
        return false;
      }
      if (this.priceInfo.payableAmount > 0 && !this.paymentMethod) {
        this.$notify({
          timeout: 5000,
          message: "Wähle bitte eine Zahlungsmethode aus.",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger"
        });
        return false;
      }
      return (!this.$refs.additionalDonationInput || await this.$refs.additionalDonationInput.validate()) &&
             (!this.$refs.generalDonationOptions || await this.$refs.generalDonationOptions.validate()) &&
             (!this.$refs.finalCheckoutOptions || await this.$refs.finalCheckoutOptions.validate());
    },
    async doPayment() {
      if (this.startingPayment) {
        return;
      }
      let initializeStripeScript = document.createElement('script');
      initializeStripeScript.setAttribute('src', 'https://js.stripe.com/v3/');
      document.head.appendChild(initializeStripeScript);

      const validationOk = await this.validateCheckout();
      if (!validationOk) {
        return;
      }
      this.startingPayment = true;
      this.$api.startPayment({
        backUrl: window.location.href.replace('cart', ''),
        challengeId: this.challenge._id,
        cartItems: this.cartItems,
        doJoin: this.doJoinWithTicket,

        joinFormData: this.doJoinWithTicket ? this.$refs.joinForm && this.$refs.joinForm.getFormData() : undefined,
        shippingFormData: this.$refs.shippingTabComponent.getShippingFormData(),
        invoiceFormData: this.$refs.shippingTabComponent.getInvoiceFormData(),
        shippingCountry: this.selectedShippingCountry,
        finalCheckoutFormData: this.$refs.finalCheckoutOptions && this.$refs.finalCheckoutOptions.formData,
        voucherCode: this.voucherCode,
        additionalDonation: this.enteredAdditionalDonation,
        additionalDonationFormData: this.$refs.additionalDonationInput && this.$refs.additionalDonationInput.getDonationFormData(),
        generalDonationFormData: this.$refs.generalDonationOptions && this.$refs.generalDonationOptions.formData,
        paymentMethod: this.paymentMethod
      })
      .catch(e => {
        console.error(e);
        this.$notify({
          timeout: 5000,
          message: "Der Zahlungsvorgang konnte leider nicht ordnungsgemäß initiiert werdern",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger"
        });
      })
      .finally(() => this.startingPayment = false);
    },
    redirect(path) {
      this.$router.push({ path, query: { redirect: "/Challenges/" + this.challenge._id } });
    }
  }
};
</script>


<style lang="css" scoped>
  .wizard >>> .md-radio {
    align-items: center;
  }
  .wizard >>> .md-radio .md-radio-container {
    top: 0;
    border: 2px solid rgba(0, 0, 0, 0.54) !important;
    width: 30px !important;
    min-width: 30px !important;
    height: 30px !important;
  }
  .wizard >>> .md-radio-label {
    display: flex;
    align-items: center;
    font-weight: 500;
    height: 30px;
    color: black;
  }
  .wizard >>> .md-radio-label button {
    margin-left: 5px;
  }
  .wizard >>> .md-radio.md-theme-default.md-checked .md-ripple {
    color: black;
  }

  .wizard >>> .md-card-wizard .md-card-header {
    text-align: unset;
  }
  .wizard >>> .md-card-wizard > .md-card-header {
    text-align: center;
  }
  .wizard >>> .md-card-wizard .nav-pills > li > a {
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .wizard >>> .md-card-wizard .nav-pills .md-icon {
    display: inline-flex;
    padding: 0;
  }
  .wizard >>> .md-card-wizard .moving-tab {
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .wizard >>> .md-card-wizard .moving-tab .md-icon {
    color: white;
  }

  hr {
    margin-top: 10px;
    margin-bottom: 18px;
    border: 0;
    border-top-style: none;
    border-top-width: 0px;
    border-top: 1px solid rgba(0,0,0,.1);
  }
</style>
